module.exports = __webpack_public_path__ + "img/back.4039e73f.png";